<p-dialog
  [header]="enableOnSave() ? 'Enable On-Demand Usage' : 'On-Demand Settings'"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: 'min(28rem, 96vw)' }"
  [breakpoints]="{ '575px': '96vw' }"
  appendTo="body"
  [(visible)]="visible"
  [closable]="!saving && !disabling"
  [closeOnEscape]="!saving && !disabling"
  (onShow)="onDialogShow()"
>
  <p class="m-0 mb-4 text-sm text-surface-switch-600">
    @if (enableOnSave()) {
      Set a monthly spending cap, then enable pay-as-you-go usage when included
      tokens run out.
    } @else {
      Update the monthly spending cap for on-demand usage, or disable it.
    }
  </p>

  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1.5">
      <label for="on-demand-budget" class="text-sm font-medium">
        Monthly budget ({{ currencyCode() }})
      </label>
      <p-inputNumber
        inputId="on-demand-budget"
        [(ngModel)]="budget"
        [min]="0"
        [minFractionDigits]="2"
        [maxFractionDigits]="4"
        [showButtons]="true"
        [allowEmpty]="true"
        [useGrouping]="false"
        class="w-full"
        inputStyleClass="w-full"
      />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-between gap-2 pt-2 w-full">
      <div>
        @if (currentlyEnabled() && !enableOnSave()) {
          <p-button
            label="Disable"
            severity="danger"
            [outlined]="true"
            [disabled]="saving || disabling"
            [loading]="disabling"
            (onClick)="disable()"
          />
        }
      </div>
      <div class="flex gap-2">
        <p-button
          label="Cancel"
          severity="secondary"
          [disabled]="saving || disabling"
          (onClick)="close()"
        />
        <p-button
          [label]="enableOnSave() ? 'Enable' : 'Save'"
          [disabled]="!canSave || saving || disabling"
          [loading]="saving"
          (onClick)="save()"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>
